import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import ConstructionIcon from "@mui/icons-material/Construction";

export const Maintenance: React.FC = () => {

    return(

        <Box
            display="flex"
            style={{ height: '100vh' }}
            alignItems="center"
            justifyContent="center"
        >
            <Card>
                <CardContent>
                    <Typography align="center" sx={{color:'rgb(230, 84, 0)', fontWeight:'bold', fontSize:'50px'}}>
                        BHP
                    </Typography>
                    <Typography>
                        This application is undergoing maintenance. Please try again later.
                    </Typography>
                    <Box display="flex" justifyContent="center">
                        <ConstructionIcon sx={{ color: '#e65400', fontSize: '100px' }} />
                    </Box>
                </CardContent>
            </Card>

        </Box>

    );

};